import { URL_PARAMS } from '../../hooks/DataFetch/constants';
import { APP_PAGES } from '../../routes/constants';

export function buildDoBoxTicketPath(
  entryId: string,
  taskGroupId: string,
): string {
  const params = new URLSearchParams({
    [URL_PARAMS.DOBOX_ID]: entryId,
    [URL_PARAMS.TASK_GROUP_ID]: taskGroupId,
  });
  return `${APP_PAGES.DOBOX}?${params.toString()}`;
}
